// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1yQju","tab":"ProcedureTabs_tab__3HrEF"};